<script setup>
import Icon from '@/Shared/Icons/Icon'
import { Link } from '@inertiajs/inertia-vue3'
import tippy from 'tippy.js'
import { onMounted, ref } from 'vue'
const props = defineProps({
  data: Object,
  brand: String,
})

const getAfURL = () => {
  const link = '/stores/afcountry/' + props.data.shopSlug
  return link
}

const getShopURL = () => {
  let link
  if (props.data.shopMapUrl == '') {
    link = 'https://maps.google.co.jp/?q=' + encodeURIComponent(props.data.shopNameJ + '@' + props.data.stateNameLocal + props.data.shopCItyJ + props.data.shopAddress1J) 
  } else {
    link = props.data.shopMapUrl
  }
  return link
}

const generateCategoryLoop = () => {
  const loop = props.data.shopBrandCategory.split(',')
  let r = []
  loop.forEach( (e) => {
    const replaced = e.replace('mysteryranch_', '') 
    r.push( replaced )
  })
  return r
}
const gradeClass = ()=>{
  let r = ''
  if ( props.brand == 'rocky_mountain_bicycles'  ){
    r = props.data.shopGrade
  } else if( props.brand == 'kona') {
    r = props.data.shopKonaGrade
  } 
  // console.log ( props.brand)
  // console.log ( r)
  return r
}

// let tippyobj = tippy('#myButton', {
//   content: 'My tooltip!',
// });

onMounted(() => {
  if( props.brand == 'mysteryranch' ) {
    tippy('.mr-everyday', {
      content: 'Everyday bag',
    })
    tippy('.mr-military', {
      content: 'Military',
    })
    tippy('.mr-mountain', {
      content: 'Mountain',
    })
    tippy('.mr-hunting', {
      content: 'Hunting',
    })
    tippy('.mr-fire', {
      content: 'Fire',
    })
  }
})

</script>

<template>
  <div class="">
    <template v-if="props.data.shopType == 0">
      <Link class="link" :href="getAfURL()">
        <h4 class="finder-each-name font-bold text-afgreen text-[15px] sm:text-[16px] mb-[8px]" :class="gradeClass()">
          <span>{{ props.data.shopNameJ }}</span>
        </h4>
      </Link>
    </template>
    <template v-else>
      <a :href="getShopURL()" target="_blank">
        <h4 class="font-bold text-afgreen text-[15px] sm:text-[16px] mb-[8px]">
          <span class="finder-each-name" :class="gradeClass()">{{ props.data.shopNameJ }}</span>
        </h4>
      </a>
    </template>
    <p class="mb-[4px]">{{ props.data.states.stateNameLocal }} {{ props.data.shopCItyJ }} {{ props.data.shopAddress1J }} {{ props.data.shopAddress2J }}</p>
    <template v-if="props.data.shopTel">
      <p class="mb-[4px]">TEL : {{ props.data.shopTel }}</p>
    </template>
    <template v-if="props.data.shopType == 0">
      <a :href="getAfURL()">
        <div class="text-afgreen font-semibold mt-[8px]">店舗詳細<Icon type="arrow" class="inline-block scale-[0.65] ml-[2px] -translate-y-[1px] [&_path]:fill-afgreen" /></div>
      </a>
    </template>
    <template v-else-if="props.data.shopType==1 && props.data.shopUrl != ''">
      <a :href="props.data.shopUrl" target="_blank">
        <div class="text-afgreen font-semibold mt-[8px]">WEBサイトはこちら<Icon type="arrow" class="inline-block scale-[0.65] ml-[2px] -translate-y-[1px] [&_path]:fill-afgreen" /></div>
      </a>
    </template>
    <template v-if="brand == 'mysteryranch'">
      <div class="mr-icon-wrap">
        <span class="title-label">取扱カテゴリー</span>
        <div class="img-group">
          <span 
            v-for="e in generateCategoryLoop()"
            :key="e"
            :class="'mr-' + e"
          ><img :src="'/img/finder/' + e + '-logo.jpg'" alt="" /></span>
        </div>
      </div>
    </template>
  </div>
</template>
